<template>
<div class="contact">
  <h3 class="contact__title">Контакты</h3>
  <ul class="contact__list">
    <li class="contact__list--item">
      <img src="./assets/contact/map.svg"
           class="contact__list--image"
           width="21" height="22" alt="Адрес:">
      115191, г. Москва, Холодильный переулок, дом 3, здание "Гончар", этаж 2, офис 14
    </li>
    <li class="contact__list--item">
      <img src="./assets/contact/phone.svg"
           class="contact__list--image"
           width="21" height="21" alt="">
      Телефон:&nbsp; <a href="tel: +74955409911" class="contact__list--link nowrap">+7 (495) 540-99-11</a>
    </li>
    <li class="contact__list--item">
      <img src="./assets/contact/mail.svg"
           class="contact__list--image"
           width="21" height="21" alt="">
      E-mail:&nbsp; <a href="mailto:info@renta.store" class="contact__list--link nowrap">info@renta.store</a>
    </li>
  </ul>
</div>
</template>


<script>
export default {
  name: "Contact"
}
</script>

<style lang="scss">
  .contact {
    &__title {
      font-weight: bold;
      color: #585C68;
      margin-bottom: 20px;
      @media (min-width: 768px) {
        font-size: 20px;
        line-height: 23px;
      }
      @media (max-width: 767px) {
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        border-top: 1px solid #96AA9C;
        padding-top: 20px;
        margin-top: 13px;
      }
     }

    &__list {
      list-style: none;
      margin: 0;
      padding: 0;
      &--item {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        font-size: 14px;
        line-height: 17px;
        color: #585C68;
        margin-bottom: 23px;
      }
      &--image {
        margin-right: 13px;
        margin-top: -2px;
      }
      &--link {
        color: inherit !important;
      }
    }
  }
</style>
